import { Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Home from './pages/Home';
import CountriesList from './pages/CountriesList';
import CountryDetail from './pages/CountryDetail';
import SpainCountryPage from './pages/SpainCountryPage';
import PortugalCountryPage from './pages/PortugalCountryPage';
import MaltaCountryPage from './pages/MaltaCountryPage';
import UAECountryPage from './pages/UAECountryPage';
import ThailandCountryPage from './pages/ThailandCountryPage';
import IndonesiaCountryPage from './pages/IndonesiaCountryPage';
import MalaysiaCountryPage from './pages/MalaysiaCountryPage';
import GreeceCountryPage from './pages/GreeceCountryPage';
import CyprusCountryPage from './pages/CyprusCountryPage';
import EstoniaCountryPage from './pages/EstoniaCountryPage';
import ItalyCountryPage from './pages/ItalyCountryPage';
import CostaRicaCountryPage from './pages/CostaRicaCountryPage';
import CroatiaCountryPage from './pages/CroatiaCountryPage';
import GermanyCountryPage from './pages/GermanyCountryPage';
import MexicoCountryPage from './pages/MexicoCountryPage';
import HungaryCountryPage from './pages/HungaryCountryPage';
import CzechRepublicCountryPage from './pages/CzechRepublicCountryPage';
import BrazilCountryPage from './pages/BrazilCountryPage';
import ColombiaCountryPage from './pages/ColombiaCountryPage';
import PanamaCountryPage from './pages/PanamaCountryPage';
import ArgentinaCountryPage from './pages/ArgentinaCountryPage';
import UruguayCountryPage from './pages/UruguayCountryPage';
import SouthAfricaCountryPage from './pages/SouthAfricaCountryPage';
import MauritiusCountryPage from './pages/MauritiusCountryPage';
import RomaniaCountryPage from './pages/RomaniaCountryPage';
import LatviaCountryPage from './pages/LatviaCountryPage';
import AlbaniaCountryPage from './pages/AlbaniaCountryPage';
import MontenegroCountryPage from './pages/MontenegroCountryPage';
import JapanCountryPage from './pages/JapanCountryPage';
import SouthKoreaCountryPage from './pages/SouthKoreaCountryPage';
import TaiwanCountryPage from './pages/TaiwanCountryPage';
import PhilippinesCountryPage from './pages/PhilippinesCountryPage';
import BahamasCountryPage from './pages/BahamasCountryPage';
import BarbadosCountryPage from './pages/BarbadosCountryPage';
import IcelandCountryPage from './pages/IcelandCountryPage';
import SeychellesCountryPage from './pages/SeychellesCountryPage';
import ArmeniaCountryPage from './pages/ArmeniaCountryPage';
import EcuadorCountryPage from './pages/EcuadorCountryPage';
import ElSalvadorCountryPage from './pages/ElSalvadorCountryPage';
import SriLankaCountryPage from './pages/SriLankaCountryPage';
import TurkeyCountryPage from './pages/TurkeyCountryPage';
import Quiz from './pages/Quiz';
import Compare from './pages/Compare';
import VisitVisas from './pages/VisitVisas';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import IndexPage from './pages/IndexPage';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import NotFound from './pages/NotFound';

import { OverridesProvider } from './hooks/useOverrides';

function ScrollToTop(){
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export default function App(){
  return (
    <OverridesProvider>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/countries" element={<CountriesList />} />
        <Route path="/countries/spain" element={<SpainCountryPage />} />
        <Route path="/countries/portugal" element={<PortugalCountryPage />} />
        <Route path="/countries/malta" element={<MaltaCountryPage />} />
        <Route path="/countries/united-arab-emirates" element={<UAECountryPage />} />
        <Route path="/countries/thailand" element={<ThailandCountryPage />} />
        <Route path="/countries/indonesia" element={<IndonesiaCountryPage />} />
        <Route path="/countries/malaysia" element={<MalaysiaCountryPage />} />
        <Route path="/countries/greece" element={<GreeceCountryPage />} />
        <Route path="/countries/cyprus" element={<CyprusCountryPage />} />
        <Route path="/countries/estonia" element={<EstoniaCountryPage />} />
        <Route path="/countries/italy" element={<ItalyCountryPage />} />
        <Route path="/countries/costa-rica" element={<CostaRicaCountryPage />} />
        <Route path="/countries/croatia" element={<CroatiaCountryPage />} />
        <Route path="/countries/germany" element={<GermanyCountryPage />} />
        <Route path="/countries/mexico" element={<MexicoCountryPage />} />
        <Route path="/countries/hungary" element={<HungaryCountryPage />} />
        <Route path="/countries/czech-republic" element={<CzechRepublicCountryPage />} />
        <Route path="/countries/brazil" element={<BrazilCountryPage />} />
        <Route path="/countries/colombia" element={<ColombiaCountryPage />} />
        <Route path="/countries/panama" element={<PanamaCountryPage />} />
        <Route path="/countries/argentina" element={<ArgentinaCountryPage />} />
        <Route path="/countries/uruguay" element={<UruguayCountryPage />} />
        <Route path="/countries/south-africa" element={<SouthAfricaCountryPage />} />
        <Route path="/countries/mauritius" element={<MauritiusCountryPage />} />
        <Route path="/countries/romania" element={<RomaniaCountryPage />} />
        <Route path="/countries/latvia" element={<LatviaCountryPage />} />
        <Route path="/countries/albania" element={<AlbaniaCountryPage />} />
        <Route path="/countries/montenegro" element={<MontenegroCountryPage />} />
        <Route path="/countries/japan" element={<JapanCountryPage />} />
        <Route path="/countries/south-korea" element={<SouthKoreaCountryPage />} />
        <Route path="/countries/taiwan" element={<TaiwanCountryPage />} />
        <Route path="/countries/philippines" element={<PhilippinesCountryPage />} />
        <Route path="/countries/bahamas" element={<BahamasCountryPage />} />
        <Route path="/countries/barbados" element={<BarbadosCountryPage />} />
        <Route path="/countries/iceland" element={<IcelandCountryPage />} />
        <Route path="/countries/seychelles" element={<SeychellesCountryPage />} />
        <Route path="/countries/armenia" element={<ArmeniaCountryPage />} />
        <Route path="/countries/ecuador" element={<EcuadorCountryPage />} />
        <Route path="/countries/el-salvador" element={<ElSalvadorCountryPage />} />
        <Route path="/countries/sri-lanka" element={<SriLankaCountryPage />} />
        <Route path="/countries/turkey" element={<TurkeyCountryPage />} />
        <Route path="/countries/:slug" element={<CountryDetail />} />
        <Route path="/quiz" element={<Quiz />} />
        <Route path="/compare" element={<Compare />} />
        <Route path="/visit-visas" element={<VisitVisas />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/nomad-index" element={<IndexPage />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </OverridesProvider>
  );
}
